import React from 'react';
import styled, { css } from 'styled-components';

import Progress from 'antd/es/progress';

import { Text } from 'components/Text';

const ProcessProgressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledProgress = styled(Progress).withConfig({
  shouldForwardProp: (prop) => !['textStyle'].includes(prop),
})`
  & .ant-progress-inner {
    width: 100% !important;
    height: 100% !important;
  }

  & .ant-progress-text {
    font-size: 100%;
    font-weight: 800;
    line-height: 1.1;
    color: ${props => props.strokeColor};
    ${props => props.textStyle ? props.textStyle : null}
  }
`;

const ProcessProgress = ({ label, progress, progressColor, textStyles = {}, labelStyles, style = {} }) => {
  return (
    <ProcessProgressWrapper>
      <StyledProgress
        type="circle"
        showInfo={true}
        percent={progress}
        strokeLinecap="round"
        strokeColor={progressColor}
        trailColor={'#232526'}
        strokeWidth={10}
        style={style}
        textStyle={css(textStyles)}
      />
      <Text
        style={{
          color: '#FFFFFF',
          fontWeight: 700,
          fontSize: '2vw',
          marginTop: '2.5vh',
          lineHeight: 1.1,
          ...labelStyles,
        }}
      >
        {label}
      </Text>
    </ProcessProgressWrapper>
  );
};

export default ProcessProgress;
